import { memo } from 'react';

import ManualIcon from '@/assets/manual-icon.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type ManualLogoProps = LogoProps;

const IManualLogo = ({ className, ...rest }: ManualLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <ManualIcon className="text-primary-500 size-5" />
    </Logo>
  );
};

export const ManualLogo = memo(IManualLogo) as typeof IManualLogo;
